module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.502e8bf5815c4dd699c1.js");
}
